export const UNDER_13 = 'under13'
export const FAILURE = 'failure'
